'use strict';

angular
    .module('App.v1.Controllers.Public')
    .value('viewmodel', ViewBag)
    .controller("App.v1.Survey.View.Controller",
        ["$scope", "$log", "App.v1.Services.Survey", "App.v1.Services.Response", "viewmodel", "$sce",
            function ($scope, $log, surveyService, responseService, viewmodel, $sce) {

                let markdownLinkPattern = /\[(.+)\]\((.+)\)/;
                let markdownReplacement = "<a href='$2' target='blank'>$1</a>";
                $scope.isLoading = true;

                if (viewmodel && viewmodel.Id) {
                    surveyService.get({ id: viewmodel.Id, includeDesign: true })
                        .$promise
                        .then(function (response) {       
                            $scope.surveyInstance = response;
                            $scope.surveyInstance.design = $scope.surveyInstance.serviceMenu.design;
                        })
                        .catch(function (error) {
                            $log.error("Failed to load survey", error);
                            $scope.errorMsg = "Unable to load data. Please try again.";
                        })
                        .finally(function () {
                            $scope.isLoading = false;
                        });
                }

                $scope.trustAsHtml = function (markdown) {
                    let html = markdown.replace(markdownLinkPattern, markdownReplacement);

                    return $sce.trustAsHtml(html);
                }

                /**
                 * UI Flag. Indicates whether survey buttons or confirmation should be shown
                 */
                $scope.surveyComplete = false;

                /**
                 * Handle Submit action
                 * @param {object} userInput - Form Data
                 */
                $scope.submit = function (userInput) {
                    let options = _.filter(_.keys(userInput.selections), function (k) { return userInput.selections[k]; });

                    if (options.length > 0 || userInput.otherText || ($scope.surveyInstance.serviceMenu.allowOther === false && _.isEmpty($scope.surveyInstance.serviceMenu.buttons))) {
                        return responseService.create(
                            {
                                snapId: viewmodel.Id,
                                options: options,
                                comment: userInput.comment,
                                otherText: userInput.otherText,
                                contactName: userInput.contactName,
                                contactEmail: userInput.contactEmail,
                                contactPhone: userInput.contactPhone,
                                hpWebsite: userInput.hp_website,
                                hpAddress: userInput.hp_address
                            }, function () {
                                $scope.surveyComplete = true;
                                $scope.error = null;
                            }, function (error) {
                                $scope.error = error.data;
                            });
                    }
                }
            }]);